export interface ClaimNonLoggedPreferencesResponse {
  claimed: boolean;
  message: string;
}

/**
 * One-time: copy non-logged UserPreferences onto the Auth0 user when the
 * HttpOnly `rgpt_device_id` cookie matches a non-logged User in Mongo.
 *
 * Backend is idempotent — safe to call multiple times.
 * `credentials: "include"` is REQUIRED so the device cookie is sent.
 */
export const claimNonLoggedPreferences = async (
  accessAuthToken: string,
): Promise<ClaimNonLoggedPreferencesResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/users/claim-non-logged-preferences`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(
      `Failed to claim non-logged preferences: ${response.status}`,
    );
  }

  const data = await response.json();

  return data;
};
